import { useDispatch } from 'react-redux';
import { useToggleCourseDraftMutation } from '../../course/courseApi';
import { setFilter, setStudentFilter } from '../dashboardFilterState';
import { dashboardApiSlice } from '../dashboardApi';

export const useDashboardActions = () => {
  const dispatch = useDispatch();
  const [toggleCourseDraft] = useToggleCourseDraftMutation();

  const setDashboardFilter = (filterValue) => {
    dispatch(setFilter(filterValue));
  };

  const setDashboardStudentFilter = (filterValue) => {
    dispatch(setStudentFilter(filterValue));
  };

  const toggleDraft = async (courseId) => {
    try {
      await toggleCourseDraft({ id: courseId }).unwrap();
      try { dispatch(dashboardApiSlice.util.invalidateTags(['Dashboard'])); } catch (e) {}
      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  };

  return {
    setDashboardFilter,
    setDashboardStudentFilter,
    toggleDraft
  };
};
